import React, { useState, useEffect } from "react";
import logo from "../assets/images/Logo-OPMS.webp";
import "../styles/Header.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Header = ({ setMostrarExpertos, cambiarIdioma, traducciones }) => {
  const [seccionActiva, setSeccionActiva] = useState("");

    useEffect(() => {
    const manejarScroll = () => {
      const secciones = document.querySelectorAll(".seccion");
      let seccionActual = "";
  
      secciones.forEach((seccion) => {
        const top = seccion.getBoundingClientRect().top;
  
        if (top <= window.innerHeight / 2 && top >= -window.innerHeight / 2) {
          seccionActual = seccion.id;
        }
      });
  
      console.log("Sección activa:", seccionActual); // Depuración
      setSeccionActiva(seccionActual);
    };
  
    window.addEventListener("scroll", manejarScroll);
    return () => window.removeEventListener("scroll", manejarScroll);
  }, []);

  const manejarClickEnlace = (idSeccion) => {
    setMostrarExpertos(false);

    setTimeout(() => {
      const seccion = document.getElementById(idSeccion);
      if (seccion) {
        seccion.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  console.log("Idioma actual:", traducciones.idioma);
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <div className="container">
        <a
          className="navbar-brand"
          href="/"
          onClick={() => manejarClickEnlace("inicio")}
        >
          <img
            src={logo}
            alt="Logo"
            className="img-fluid"
            style={{ maxHeight: "70px", width: "auto" }}
          />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse justify-content-center"
          id="navbarNav"
        >
          <ul className="navbar-nav">
            <li className="nav-item">
              <a
                className={`nav-link ${
                  seccionActiva === "servicios" ? "active" : ""
                }`}
                href="#servicios"
                onClick={() => manejarClickEnlace("servicios")}
              >
                {traducciones.header
                  ? traducciones.header.servicios
                  : "Servicios"}
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${
                  seccionActiva === "sobre" ? "active" : ""
                }`}
                href="#sobre"
                onClick={() => manejarClickEnlace("sobre")}
              >
                {traducciones.header
                  ? traducciones.header["sobre-nosotros"]
                  : "Sobre nosotros"}
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${
                  seccionActiva === "como" ? "active" : ""
                }`}
                href="#como"
                onClick={() => manejarClickEnlace("como")}
              >
                {traducciones.header
                  ? traducciones.header["como-trabajamos"]
                  : "¿Cómo trabajamos?"}
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${
                  seccionActiva === "trayectoria" ? "active" : ""
                }`}
                href="#trayectoria"
                onClick={() => manejarClickEnlace("trayectoria")}
              >
                {traducciones.header
                  ? traducciones.header.trayectoria
                  : "Trayectoria"}
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${
                  seccionActiva === "contacto" ? "active" : ""
                }`}
                href="#contacto"
                onClick={() => manejarClickEnlace("contacto")}
              >
                {traducciones.header
                  ? traducciones.header.contacto
                  : "Contacto"}
              </a>
            </li>
            {/* Menú de idiomas */}
            <li className="nav-item d-none d-lg-flex align-items-center ms-auto">
              <button
                className={`btn btn-link nav-link ${
                  traducciones.idioma === "es" ? "activo" : ""
                }`}
                onClick={() => cambiarIdioma("es")}
              >
                ESP
              </button>
              <button
                className={`btn btn-link nav-link ${
                  traducciones.idioma === "en" ? "activo" : ""
                }`}
                onClick={() => cambiarIdioma("en")}
              >
                ENG
              </button>
            </li>

            {/* Menú de idiomas para pantallas pequeñas */}
            <li className="nav-item d-lg-none idiomas-movil">
              <button
                className={`btn btn-link nav-link ${
                  traducciones.idioma === "es" ? "activo" : ""
                }`}
                onClick={() => cambiarIdioma("es")}
              >
                ESP
              </button>
              <button
                className={`btn btn-link nav-link ${
                  traducciones.idioma === "en" ? "activo" : ""
                }`}
                onClick={() => cambiarIdioma("en")}
              >
                ENG
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
